<div class="bc-lab-req">
    <form *ngIf="form" [formGroup]="form">
        <div
            style="
                display: flex;
                justify-content: space-between;
                color: #294c95;
            "
        >
            <div style="flex: 1">
                <svg
                    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:svg="http://www.w3.org/2000/svg"
                    version="1.1"
                    id="svg2"
                    width="300"
                    height="100"
                    viewBox="0 0 480.38666 126.38667"
                >
                    <defs id="defs6" />
                    <g
                        id="g8"
                        inkscape:groupmode="layer"
                        inkscape:label="ink_ext_XXXXXX"
                        transform="matrix(1.3333333,0,0,-1.3333333,0,126.38667)"
                    >
                        <g id="g10" transform="scale(0.1)">
                            <path
                                d="M 1.44141,54.8516 V 650.414 H 144.371 V 172.289 h 202.5 V 54.8516 H 1.44141"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path12"
                            />
                            <path
                                d="m 1017.41,578.234 c -41.453,0 -51.566,-11.039 -51.566,-35.699 v -87.472 h 89.996 V 361.121 H 965.844 V 58.3984 H 826.242 V 361.121 h -63.711 v 93.942 h 63.711 v 103.625 c 0,83.382 54.629,117.414 151.727,117.414 34.391,0 63.731,-4.25 87.991,-12.782 v -94.429 c -14.17,5.961 -28.31,9.343 -48.55,9.343"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path14"
                            />
                            <path
                                d="m 1494.3,326.227 v 5.23 c 0,33.082 -4.38,50.516 -17.62,67.031 -14.33,17.418 -35.27,26.153 -65.04,26.153 -56.23,0 -88.18,-34.848 -88.18,-96.688 v -1.726 z m 146.61,-222.063 c -65.03,-41.7929 -133.36,-61.8437 -212.77,-61.8437 -162.02,0 -266.72,90.6177 -266.72,230.7737 0,80.136 20.93,133.254 70.51,176.773 46.33,40.957 102.52,60.09 177.52,60.09 65,0 126.75,-17.394 163.13,-47.027 51.82,-41.789 74.94,-101.867 74.94,-195.071 v -26.961 h -326.25 v -3.492 c 0,-68.812 42.95,-107.988 119.04,-107.988 50.7,0 98.09,14.801 143.28,44.406 l 57.32,-69.66"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path16"
                            />
                            <path
                                d="M 712.176,735.707 C 663.234,707.246 443.27,573.547 229.941,630.293 536.352,512.219 534.375,238.102 426.762,1.44141 617.344,212.379 607.594,475.344 588.535,539.613 c 44.102,32.977 98.781,103.254 123.641,196.094"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path18"
                            />
                            <path
                                d="m 532.164,828.043 c 0,-65.391 -52.492,-118.387 -117.309,-118.387 -64.781,0 -117.296,52.996 -117.296,118.387 0,65.398 52.515,118.41 117.296,118.41 64.817,0 117.309,-53.012 117.309,-118.41"
                                style="
                                    fill: #e02a2a;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path20"
                            />
                            <path
                                d="M 1792.59,54.0664 V 646.164 h 87.99 v -504.98 h 206.6 V 54.0664 h -294.59"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path22"
                            />
                            <path
                                d="m 2455.65,243.543 c -23.47,11.84 -53.63,19.457 -100.56,19.457 -55.31,0 -90.5,-25.375 -90.5,-65.984 0,-43.977 27.66,-73.582 84.64,-73.582 46.07,0 86.3,28.757 106.42,56.675 z m 0,-189.4766 v 43.9961 c -30.16,-30.457 -72.9,-53.2969 -120.69,-53.2969 -71.21,0 -152.5,40.5977 -152.5,149.7144 0,98.973 75.41,143.801 175.14,143.801 41.07,0 73.74,-5.918 98.05,-16.918 v 32.989 c 0,48.211 -29.33,75.281 -82.97,75.281 -45.25,0 -80.43,-8.465 -114.81,-27.906 l -33.5,65.968 c 41.9,26.223 88.82,39.758 150.83,39.758 98.04,0 165.07,-48.211 165.07,-148.867 V 54.0664 h -84.62"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path24"
                            />
                            <path
                                d="m 2852.22,427.086 c -41.07,0 -77.09,-27.918 -99.72,-56.676 V 183.473 c 19.28,-26.211 59.51,-58.352 103.06,-58.352 62.03,0 95.54,47.363 95.54,141.25 0,111.656 -35.19,160.715 -98.88,160.715 z m 11.73,-382.3321 c -44.41,0 -86.32,23.6875 -110.6,50.7461 V 54.0586 h -85.48 V 625.852 l 85.48,44.843 V 455.844 c 31.84,29.609 68.7,51.597 114.79,51.597 94.68,0 169.27,-69.367 169.27,-238.535 0,-152.265 -82.12,-224.1521 -173.46,-224.1521"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path26"
                            />
                            <path
                                d="m 3286.57,44.7578 c -59.5,0 -124.03,23.6875 -168.45,56.6762 l 39.39,65.968 c 41.07,-28.757 87.16,-43.976 128.22,-43.976 54.47,0 80.45,17.754 80.45,49.058 0,33.84 -38.55,49.911 -102.23,74.434 -94.72,37.223 -129.07,69.363 -129.07,139.566 0,79.512 62.01,120.961 150.01,120.961 55.31,0 109.77,-20.308 149.16,-49.066 l -37.7,-66.813 c -36.05,25.372 -72.09,38.059 -113.96,38.059 -41.91,0 -60.34,-16.922 -60.34,-40.594 0,-22.004 15.08,-38.074 81.27,-64.293 98.04,-38.062 148.32,-65.136 148.32,-148.871 0,-98.1209 -78.77,-131.1092 -165.07,-131.1092"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path28"
                            />
                            <path
                                d="m 3538.55,411.035 h -12.23 v -15.746 h 11.87 c 6.69,0 9.26,2.774 9.26,7.984 0,4.602 -2.57,7.762 -8.9,7.762 z m 7.79,-56.176 -11.87,24.485 h -8.15 v -24.485 h -19.84 v 72.7 h 32.63 c 17.06,0 28.37,-6.512 28.37,-23.743 0,-10.945 -5.19,-17.621 -13.16,-21.312 l 14.48,-27.645 z m -11.87,88.45 c -30.4,0 -53.2,-21.504 -53.2,-53.778 0,-32.246 22.8,-53.765 53.2,-53.765 30.43,0 53.23,21.519 53.23,53.765 0,32.274 -22.8,53.778 -53.23,53.778 z m 0,-120.696 c -38.01,0 -66.92,28.918 -66.92,66.918 0,38.028 28.91,66.942 66.92,66.942 38.02,0 66.97,-28.914 66.97,-66.942 0,-38 -28.95,-66.918 -66.97,-66.918"
                                style="
                                    fill: #0000a0;
                                    fill-opacity: 1;
                                    fill-rule: evenodd;
                                    stroke: none;
                                "
                                id="path30"
                            />
                        </g>
                    </g>
                </svg>
            </div>
            <div
                style="
                    flex: 1;
                    text-align: right;
                    max-width: 300px;
                    padding: 10px;
                "
            >
                <div style="font-size: 22px">Laboratory Requisition</div>
                <div style="font-size: 14px">
                    This requisition form, when completed, constitutes a
                    referral to LifeLabs laboratory physicians. It is for the
                    use of authorized health care providers only.
                </div>
            </div>
            <div
                style="
                    flex: 1;
                    border: 1px solid #294c95;
                    border-bottom: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
            >
                THIS AREA IS FOR LAB USE
            </div>
        </div>
        <div
            style="
                display: flex;
                flex-direction: column;
                border: 2px solid #294c95;
                color: #294c95;
                overflow: hidden;
            "
        >
            <div class="grid">
                <div class="title">
                    <div
                        style="
                            text-align: center;
                            font-size: 18px;
                            line-height: 1.2;
                            background-color: #e5e4f1;
                            border-bottom: 3px solid #294c95;
                            padding: 4px 8px 5px;
                        "
                    >
                        <b>COMPLETE</b> and <b>ACCURATE</b> information is
                        required in all shaded areas.
                    </div>
                </div>
                <div class="name">
                    <div
                        style="
                            display: flex;
                            justify-content: space-between;
                            background-color: #e5e4f1;
                            height: 100%;
                        "
                    >
                        <div style="padding: 4px">
                            <label>Patient Surname (from CareCard)</label>
                            <input formControlName="surname" type="text" />
                        </div>
                        <div style="padding: 4px; text-align: center">
                            <label>First</label>
                            <input formControlName="first" type="text" />
                        </div>
                        <div style="padding: 4px; text-align: center">
                            <label>Initial(s)</label>
                            <input formControlName="initials" type="text" />
                        </div>
                    </div>
                </div>
                <div class="dob">
                    <div
                        style="
                            height: 100%;
                            border-left: 1px solid #294c95;
                            padding: 4px 4px 0;
                            background-color: #e5e4f1;
                        "
                    >
                        <label>Date of Birth</label>
                        <div
                            formGroupName="dob"
                            style="display: flex; height: 100%"
                        >
                            <div
                                style="
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    text-align: center;
                                "
                            >
                                <input
                                    formControlName="day"
                                    type="number"
                                    style="height: 22px; text-align: center"
                                />
                                <small>DAY</small>
                            </div>
                            <div
                                style="
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    text-align: center;
                                    border-left: 1px solid #294c95;
                                "
                            >
                                <input
                                    formControlName="month"
                                    type="number"
                                    style="height: 22px; text-align: center"
                                />
                                <small>MONTH</small>
                            </div>
                            <div
                                style="
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    text-align: center;
                                    border-left: 1px solid #294c95;
                                "
                            >
                                <input
                                    formControlName="year"
                                    type="number"
                                    style="height: 22px; text-align: center"
                                />
                                <small>YEAR</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sex">
                    <div
                        formGroupName="sex"
                        style="
                            height: 100%;
                            border-left: 1px solid #294c95;
                            padding: 4px 4px 0;
                            background-color: #e5e4f1;
                        "
                    >
                        <label>Sex</label>
                        <div style="height: 5px"></div>
                        <div style="display: flex">
                            <div style="flex: 1; display: flex">
                                <input
                                    formControlName="female"
                                    type="checkbox"
                                />
                                <span>F</span>
                            </div>
                            <div style="flex: 1; display: flex">
                                <input formControlName="male" type="checkbox" />
                                <span>M</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="billing" formGroupName="billing">
                    <div
                        style="
                            height: 100%;
                            background-color: #e5e4f1;
                            padding: 4px 4px 0;
                            border-top: 1px solid #294c95;
                        "
                    >
                        <div style="display: flex; gap: 18px; width: 100%">
                            <div><label>Bill to:</label></div>
                            <div>
                                <input formControlName="MSP" type="checkbox" />
                                <label>MSP</label>
                            </div>
                            <div>
                                <input formControlName="ICBC" type="checkbox" />
                                <label>ICBC</label>
                            </div>
                            <div>
                                <input
                                    formControlName="workSafeBC"
                                    type="checkbox"
                                />
                                <label>WorkSafeBC</label>
                            </div>
                            <div>
                                <input
                                    formControlName="patient"
                                    type="checkbox"
                                />
                                <label>Patient</label>
                            </div>
                            <div
                                formGroupName="other"
                                style="
                                    display: flex;
                                    flex-grow: 1;
                                    align-items: center;
                                "
                            >
                                <input formControlName="yes" type="checkbox" />
                                <label>Other</label>
                                <input
                                    formControlName="value"
                                    style="
                                        border-bottom: 1px solid #294c95;
                                        height: 20px;
                                    "
                                    type="text"
                                />
                            </div>
                        </div>
                        <div
                            style="
                                display: flex;
                                gap: 18px;
                                padding-top: 10px;
                                padding-bottom: 4px;
                            "
                        >
                            <div
                                style="
                                    display: flex;
                                    align-items: center;
                                    flex: 1;
                                "
                            >
                                <label>PHN</label>
                                <input
                                    formControlName="PHN"
                                    style="
                                        border-bottom: 1px solid #294c95;
                                        height: 20px;
                                    "
                                    type="text"
                                />
                            </div>
                            <div
                                style="
                                    display: flex;
                                    align-items: center;
                                    flex: 1;
                                "
                            >
                                <label style="white-space: nowrap"
                                    >I.D. Number</label
                                >
                                <input
                                    formControlName="idNumber"
                                    style="
                                        border-bottom: 1px solid #294c95;
                                        height: 20px;
                                    "
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chart-number">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div style="padding: 4px">
                                <label>Chart Number</label>
                                <input
                                    formControlName="chartNumber"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="room">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div style="padding: 4px">
                                <label>Room # (LTC use only)</label>
                                <input
                                    formControlName="roomNumber"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="address" formGroupName="address">
                    <div
                        style="
                            display: flex;
                            justify-content: space-between;
                            background-color: #e5e4f1;
                            border-top: 1px solid #294c95;
                            height: 100%;
                        "
                    >
                        <div style="padding: 4px">
                            <label>Patient Address</label>
                            <textarea
                                formControlName="patientAddress"
                                type="text"
                            ></textarea>
                        </div>
                        <div style="padding: 4px; text-align: center">
                            <label>City, Province</label>
                            <input formControlName="cityProvince" type="text" />
                        </div>
                        <div style="padding: 4px; text-align: center">
                            <label>Postal Code</label>
                            <input formControlName="postalCode" type="text" />
                        </div>
                    </div>
                </div>
                <div class="tel">
                    <div
                        style="
                            height: 100%;
                            background-color: #e5e4f1;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div style="padding: 4px">
                                <label>Patient Telephone Number</label>
                                <input
                                    formControlName="patientTel"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div10">
                    <div
                        style="
                            height: 100%;
                            background-color: #e5e4f1;
                            border-top: 1px solid #294c95;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div style="padding: 4px">
                                <label
                                    >Ordering Physician, Address, MSP
                                    Practitioner Number</label
                                >
                                <div>
                                    <textarea
                                        formControlName="practitionerNumber"
                                        rows="4"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div11" formGroupName="locumFor">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-top: 1px solid #294c95;
                            border-left: 1px solid #294c95;
                        "
                    >
                        <div style="display: flex">
                            <div style="padding: 4px; width: 100%">
                                <div>Locum for:</div>
                                <div style="height: 15px"></div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        gap: 12px;
                                    "
                                >
                                    <div style="white-space: nowrap">
                                        Physician
                                    </div>
                                    <input
                                        formControlName="physician"
                                        type="text"
                                        style="border-bottom: 1px solid #294c95"
                                    />
                                </div>
                                <div style="height: 15px"></div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        gap: 12px;
                                    "
                                >
                                    <div style="white-space: nowrap">MSC #</div>
                                    <input
                                        formControlName="MSC"
                                        type="text"
                                        style="border-bottom: 1px solid #294c95"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div12">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-top: 1px solid #294c95;
                            border-left: 1px solid #294c95;
                        "
                    >
                        <div style="display: flex">
                            <div style="padding: 4px; width: 100%">
                                <label>C0 Number</label>
                                <div>
                                    <textarea
                                        formControlName="c0Number"
                                        rows="5"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div13">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Date/Time of Collection</label>
                        <input formControlName="dateOfCollection" type="text" />
                    </div>
                </div>
                <div class="div14">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Phlebotomist</label>
                        <input formControlName="phlebotomist" type="text" />
                    </div>
                </div>
                <div class="div15">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Data Entry</label>
                        <input formControlName="dataEntry" type="text" />
                    </div>
                </div>
                <div class="div16">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Date/Time/Name of Medication</label>
                        <input formControlName="medication" type="text" />
                    </div>
                </div>
                <div class="div17">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Copy to: Address, MSP Practitioner Number</label>
                        <div>
                            <textarea
                                formControlName="copyTo"
                                rows="5"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="div18" formGroupName="pregnant">
                    <div
                        style="
                            height: 100%;
                            border-top: 1px solid #294c95;
                            border-left: 1px solid #294c95;
                            padding: 4px 4px 0;
                            background-color: #ffffff;
                        "
                    >
                        <label>Pregnant</label>
                        <div style="height: 10px"></div>
                        <div style="display: flex">
                            <div style="flex: 1">
                                <input formControlName="yes" type="checkbox" />
                                <span>Yes</span>
                            </div>
                            <div style="flex: 1">
                                <input formControlName="no" type="checkbox" />
                                <span>No</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div19" formGroupName="fasting">
                    <div
                        style="
                            height: 100%;
                            border-top: 1px solid #294c95;
                            border-left: 1px solid #294c95;
                            padding: 4px 4px 0;
                            background-color: #ffffff;
                        "
                    >
                        <div style="flex: 1">
                            <input formControlName="yes" type="checkbox" />
                            <label>Fasting</label>
                        </div>
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                gap: 12px;
                            "
                        >
                            <input
                                formControlName="hoursPrior"
                                type="number"
                                style="border-bottom: 1px solid #294c95"
                            />
                            <div style="white-space: nowrap; font-size: 11px">
                                hours prior to test
                            </div>
                        </div>
                    </div>
                </div>
                <div class="div20" formGroupName="phoneFax">
                    <div
                        style="
                            height: 100%;
                            border-top: 1px solid #294c95;
                            border-left: 1px solid #294c95;
                            padding: 4px 4px 0;
                            background-color: #ffffff;
                        "
                    >
                        <div style="display: flex">
                            <div style="flex: 1">
                                <input
                                    formControlName="phone"
                                    type="checkbox"
                                />
                                <span>Phone</span>
                            </div>
                            <div style="flex: 1">
                                <input formControlName="fax" type="checkbox" />
                                <span>Fax</span>
                            </div>
                        </div>
                        <div>
                            <input formControlName="value" type="text" />
                        </div>
                    </div>
                </div>
                <div class="div21">
                    <div
                        style="
                            height: 100%;
                            background-color: #ffffff;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label>Telephone Requisition Received By:</label>
                        <input
                            formControlName="telephoneRequisitionReceivedBy"
                            type="text"
                        />
                        <div style="text-align: center">
                            <small>INITIAL/DATE</small>
                        </div>
                    </div>
                </div>
                <div class="div22">
                    <div
                        style="
                            height: 100%;
                            background-color: #e5e4f1;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px;
                        "
                    >
                        <label
                            >Diagnosis and indications for guideline protocol
                            and special tests</label
                        >
                        <div>
                            <textarea
                                formControlName="diagnosis"
                                rows="3"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="div23">
                    <div
                        style="
                            color: rgb(183, 9, 9);
                            background-color: #e5e4f1;
                            height: 100%;
                            border-left: 1px solid #294c95;
                            border-top: 1px solid #294c95;
                            padding: 4px 4px 0;
                        "
                    >
                        For tests indicated with a shaded tick box
                        <label class="shaded" style="display: inline">
                            <input type="checkbox" />
                            <span class="checkmark"></span> </label
                        >, consult provincial guidelines and protocols
                        (www.BCGuidelines.ca)
                    </div>
                </div>
            </div>
            <div class="grid2">
                <div
                    formGroupName="HEMATOLOGY"
                    class="HEMATOLOGY"
                    style="border-top: 2px solid #7388b8"
                >
                    <div class="heading">HEMATOLOGY</div>
                    <div style="padding: 3px">
                        <div style="display: flex; align-items: baseline">
                            <div style="flex: 1">
                                <div>
                                    <input
                                        formControlName="hematologyProfile"
                                        type="checkbox"
                                    />
                                    <span>Hematology profile</span>
                                </div>
                                <div>
                                    <input
                                        formControlName="INR"
                                        type="checkbox"
                                    />
                                    <span>INR</span>
                                </div>
                                <div>
                                    <input
                                        formControlName="ferritin"
                                        type="checkbox"
                                    />
                                    <span
                                        >Ferritin (query iron deficiency)</span
                                    >
                                </div>
                            </div>
                            <div style="flex: 1" formGroupName="anticoagulant">
                                <div style="display: flex; align-items: center">
                                    On Anticoagulant?
                                    <div>
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        <span>yes</span>
                                    </div>
                                    <div>
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        <span>No</span>
                                    </div>
                                </div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        gap: 12px;
                                    "
                                >
                                    <div style="white-space: nowrap">
                                        Specify:
                                    </div>
                                    <input
                                        formControlName="specify"
                                        type="text"
                                        style="border-bottom: 1px solid #294c95"
                                    />
                                </div>
                            </div>
                        </div>
                        <div formGroupName="HFE">
                            <div>
                                HFE – Hemochromatosis (check ONE box only)
                            </div>
                            <div style="padding-left: 1rem">
                                <label class="shaded"
                                    >Confirm diagnosis (ferritin first ± TS, ±
                                    DNA testing)
                                    <input
                                        formControlName="confirmDiagnosis"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Sibling/parent is C282Y/C282Y homozygote
                                    (DNA testing)
                                    <input
                                        formControlName="siblingParent"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="MICROBIOLOGY"
                    class="MICROBIOLOGY"
                    style="
                        border-left: 2px solid #7388b8;
                        border-top: 2px solid #7388b8;
                    "
                >
                    <div
                        class="heading"
                        style="display: flex; gap: 4px; align-items: center"
                    >
                        MICROBIOLOGY
                        <div
                            style="
                                font-size: 10px;
                                line-height: 12px;
                                text-align: left;
                            "
                        >
                            LABEL ALL SPECIMENS WITH PATIENT’S FIRST AND LAST
                            NAME, DOB AND/OR PHN & SITE
                        </div>
                    </div>
                    <div style="padding: 3px">
                        <div formGroupName="ROUTINE_CULTURE">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >ROUTINE CULTURE</label
                                >
                            </div>

                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    gap: 4px;
                                "
                            >
                                <div
                                    formGroupName="antibiotics"
                                    style="
                                        display: flex;
                                        align-items: center;
                                        gap: 10px;
                                    "
                                >
                                    <div style="white-space: nowrap">
                                        On Antibiotics?
                                    </div>

                                    <div style="display: flex">
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        <span>yes</span>
                                    </div>
                                    <div style="display: flex">
                                        <input
                                            formControlName="no"
                                            type="checkbox"
                                        />
                                        <span>No</span>
                                    </div>
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                            gap: 12px;
                                        "
                                    >
                                        <div style="white-space: nowrap">
                                            Specify:
                                        </div>
                                        <input
                                            formControlName="specify"
                                            type="text"
                                            style="
                                                border-bottom: 1px solid #294c95;
                                                height: 18px;
                                            "
                                        />
                                    </div>
                                </div>

                                <div style="display: flex; gap: 20px">
                                    <div style="display: flex">
                                        <input
                                            formControlName="throat"
                                            type="checkbox"
                                        />
                                        <span>Throat</span>
                                    </div>
                                    <div style="display: flex">
                                        <input
                                            formControlName="sputum"
                                            type="checkbox"
                                        />
                                        <span>Sputum</span>
                                    </div>
                                    <div style="display: flex">
                                        <input
                                            formControlName="blood"
                                            type="checkbox"
                                        />
                                        <span>Blood</span>
                                    </div>
                                    <div style="display: flex">
                                        <input
                                            formControlName="urine"
                                            type="checkbox"
                                        />
                                        <span>Urine</span>
                                    </div>
                                </div>

                                <div
                                    formGroupName="superficialWound"
                                    style="display: flex"
                                >
                                    <div style="display: flex">
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Superficial Wound, Site</span
                                        >
                                    </div>
                                    <input
                                        formControlName="site"
                                        type="text"
                                        style="
                                            border-bottom: 1px solid #294c95;
                                            height: 18px;
                                        "
                                    />
                                </div>
                                <div
                                    formGroupName="deepWound"
                                    style="display: flex"
                                >
                                    <div style="display: flex">
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Deep Wound, Site</span
                                        >
                                    </div>
                                    <input
                                        formControlName="site"
                                        type="text"
                                        style="
                                            border-bottom: 1px solid #294c95;
                                            height: 18px;
                                        "
                                    />
                                </div>
                                <div
                                    formGroupName="other"
                                    style="display: flex"
                                >
                                    <div style="display: flex">
                                        <input
                                            formControlName="yes"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Other:</span
                                        >
                                    </div>
                                    <input
                                        formControlName="value"
                                        type="text"
                                        style="
                                            border-bottom: 1px solid #294c95;
                                            height: 18px;
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                        <div formGroupName="VAGINITIS">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >VAGINITIS</label
                                >
                            </div>

                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    gap: 4px;
                                "
                            >
                                <div style="display: flex; align-items: center">
                                    <input
                                        formControlName="initial"
                                        type="checkbox"
                                    />
                                    <span style="white-space: nowrap"
                                        >Initial (smear for BV & yeast
                                        only)</span
                                    >
                                </div>
                                <div style="display: flex; align-items: center">
                                    <input
                                        formControlName="chronicRecurrent"
                                        type="checkbox"
                                    />
                                    <span style="white-space: nowrap"
                                        >Chronic/recurrent (smear, culture,
                                        trichomonas)</span
                                    >
                                </div>
                                <div style="display: flex; align-items: center">
                                    <input
                                        formControlName="trichomonasTesting"
                                        type="checkbox"
                                    />
                                    <span style="white-space: nowrap"
                                        >Trichomonas testing</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div formGroupName="GROUP_B_STREP_SCREEN">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >GROUP B STREP SCREEN
                                </label>
                                <span style="text-decoration: underline">
                                    (Pregnancy only)
                                </span>
                            </div>

                            <div
                                style="
                                    display: flex;
                                    flex-direction: row;
                                    gap: 10px;
                                "
                            >
                                <div style="display: flex; align-items: center">
                                    <input
                                        formControlName="vaginoAnorectalSwab"
                                        type="checkbox"
                                    />
                                    <span style="white-space: nowrap"
                                        >Vagino-anorectal swab</span
                                    >
                                </div>
                                <div style="display: flex; align-items: center">
                                    <input
                                        formControlName="penicillinAllergy"
                                        type="checkbox"
                                    />
                                    <span style="white-space: nowrap"
                                        >Penicillin allergy</span
                                    >
                                </div>
                            </div>
                        </div>

                        <div formGroupName="CHLAMYDIA_GONORRHEA_NAAT">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >CHLAMYDIA (CT) & GONORRHEA (GC) by NAAT
                                </label>
                            </div>

                            <div style="display: flex">
                                <div>Source/site:</div>
                                <div
                                    style="
                                        display: grid;
                                        grid-template-columns: repeat(3, 1fr);
                                        grid-template-rows: repeat(3, 1fr);
                                        grid-column-gap: 0px;
                                        grid-row-gap: 8px;
                                    "
                                >
                                    <div style="grid-area: 1 / 1 / 2 / 2">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="urethra"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Urethra</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 1 / 2 / 2 / 3">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="cervix"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Cervix</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 1 / 3 / 2 / 4">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="urine"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Urine</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 2 / 1 / 3 / 2">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="vagina"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Vagina</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 2 / 2 / 3 / 3">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="throat"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Throat</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 2 / 3 / 3 / 4">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="rectum"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Rectum</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        formGroupName="other"
                                        style="grid-area: 3 / 1 / 4 / 4"
                                    >
                                        <div
                                            style="
                                                display: flex;
                                                flex-grow: 1;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="yes"
                                                for
                                                type="checkbox"
                                            />
                                            <div>Other</div>
                                            <input
                                                formControlName="value"
                                                style="
                                                    border-bottom: 1px solid
                                                        #294c95;
                                                    height: 14px;
                                                "
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div formGroupName="GONORRHEA_CULTURE">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >GONORRHEA (GC) CULTURE
                                </label>
                            </div>

                            <div style="display: flex">
                                <div>Source/site:</div>
                                <div
                                    style="
                                        display: grid;
                                        grid-template-columns: repeat(4, 1fr);
                                        grid-template-rows: repeat(2, 1fr);
                                        grid-column-gap: 0px;
                                        grid-row-gap: 8px;
                                    "
                                >
                                    <div style="grid-area: 1 / 1 / 2 / 2">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="cervix"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Cervix</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 1 / 2 / 2 / 3">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="urethra"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Urethra</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 1 / 3 / 2 / 4">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="throat"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Throat</span
                                            >
                                        </div>
                                    </div>
                                    <div style="grid-area: 1 / 4 / 2 / 5">
                                        <div
                                            style="
                                                display: flex;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="rectum"
                                                type="checkbox"
                                            />
                                            <span style="white-space: nowrap"
                                                >Rectum</span
                                            >
                                        </div>
                                    </div>
                                    <div
                                        formGroupName="other"
                                        style="grid-area: 2 / 1 / 3 / 5"
                                    >
                                        <div
                                            style="
                                                display: flex;
                                                flex-grow: 1;
                                                align-items: center;
                                            "
                                        >
                                            <input
                                                formControlName="yes"
                                                type="checkbox"
                                            />
                                            <div>Other</div>
                                            <input
                                                formControlName="value"
                                                style="
                                                    border-bottom: 1px solid
                                                        #294c95;
                                                    height: 14px;
                                                "
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div formGroupName="STOOL_SPECIMENS">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >STOOL SPECIMENS
                                </label>
                            </div>

                            <div
                                style="
                                    display: flex;
                                    align-items: center;
                                    gap: 40px;
                                "
                            >
                                <div>History of bloody stools?</div>
                                <label class="shaded"
                                    >Yes
                                    <input
                                        formControlName="historyOfBloodyStools"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    grid-template-rows: repeat(2, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 8px;
                                    margin-top: 8px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    <label
                                        class="shaded"
                                        style="white-space: nowrap"
                                        >C. difficile testing
                                        <input
                                            formControlName="cDifficileTesting"
                                            type="checkbox"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <label
                                        class="shaded"
                                        style="white-space: nowrap"
                                        >Stool culture
                                        <input
                                            formControlName="stoolCulture"
                                            type="checkbox"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div style="grid-area: 1 / 3 / 2 / 4">
                                    <label
                                        class="shaded"
                                        style="white-space: nowrap"
                                        >Stool ova & parasite exam
                                        <input
                                            formControlName="stoolOva"
                                            type="checkbox"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div style="grid-area: 2 / 1 / 3 / 4">
                                    <label class="shaded"
                                        >Stool ova & parasite (high risk, submit
                                        2 samples)
                                        <input
                                            formControlName="stoolOva2"
                                            type="checkbox"
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div formGroupName="DERMATOPHYTES">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >DERMATOPHYTES
                                </label>
                            </div>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(4, 1fr);
                                    grid-template-rows: repeat(3, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="dermatophyteCulture"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Dermatophyte culture</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 1 / 3 / 2 / 5">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="KOH"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >KOH prep (direct exam)</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 2 / 1 / 3 / 2">
                                    Specimen:
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="skin"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Skin</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 2 / 3 / 3 / 4">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="nail"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Nail</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 2 / 4 / 3 / 5">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="hair"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Hair</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 3 / 1 / 4 / 5">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <label>Site:</label>
                                        <input
                                            formControlName="site"
                                            style="
                                                border-bottom: 1px solid #294c95;
                                                height: 14px;
                                            "
                                            type="text"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div formGroupName="MYCOLOGY">
                            <div style="margin-top: 14px; margin-bottom: 10px">
                                <label style="text-decoration: underline"
                                    >MYCOLOGY
                                </label>
                            </div>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    grid-template-rows: 1fr;
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="yeast"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Yeast</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="fungus"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Fungus</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 1 / 3 / 2 / 4">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <label>Site:</label>
                                        <input
                                            formControlName="site"
                                            style="
                                                border-bottom: 1px solid #294c95;
                                                height: 14px;
                                            "
                                            type="text"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="URINE_TESTS"
                    class="URINE_TESTS"
                    style="
                        border-top: 2px solid #7388b8;
                        border-left: 2px solid #7388b8;
                    "
                >
                    <div class="heading">URINE TESTS</div>

                    <div
                        style="
                            padding: 4px;
                            display: flex;
                            flex-direction: column;
                            gap: 4px;
                        "
                    >
                        <div>
                            <label class="shaded"
                                >Macroscopic → microscopic if dipstick positive
                                <input
                                    formControlName="macroscopic1"
                                    type="checkbox"
                                />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div>
                            <label class="shaded"
                                >Macroscopic → urine culture if pyuria or
                                nitrite present
                                <input
                                    formControlName="macroscopic2"
                                    type="checkbox"
                                />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div style="display: flex; gap: 30px">
                            <label class="shaded"
                                >Macroscopic (dipstick)
                                <input
                                    formControlName="macroscopic3"
                                    type="checkbox"
                                />
                                <span class="checkmark"></span>
                            </label>
                            <label class="shaded"
                                >Microscopic*
                                <input
                                    formControlName="microscopic"
                                    type="checkbox"
                                />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div
                            style="
                                display: flex;
                                flex-direction: column;
                                padding-left: 22px;
                            "
                        >
                            <div>
                                *Clinical information for microscopic required:
                            </div>
                            <div style="padding-right: 44px">
                                <input
                                    formControlName="info"
                                    style="
                                        border-bottom: 1px solid #294c95;
                                        height: 20px;
                                    "
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    formGroupName="CHEMISTRY"
                    class="CHEMISTRY"
                    style="border-top: 2px solid #7388b8"
                >
                    <div class="heading">CHEMISTRY</div>
                    <div style="padding: 4px">
                        <div
                            style="
                                display: flex;
                                flex-direction: column;
                                border-bottom: 1px solid #294c95;
                            "
                        >
                            <div style="display: flex; align-items: center">
                                <input
                                    formControlName="glucoseFasting"
                                    type="checkbox"
                                />
                                <span style="white-space: nowrap"
                                    >Glucose - fasting (see reverse for patient
                                    instructions)</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input
                                    formControlName="glucoseRandom"
                                    type="checkbox"
                                />
                                <span style="white-space: nowrap"
                                    >Glucose - random</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input formControlName="GTT1" type="checkbox" />
                                <span style=""
                                    >GTT - gestational diabetes screen (50 g
                                    load, 1 hour post-load)</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input formControlName="GTT2" type="checkbox" />
                                <span style=""
                                    >GTT - gestational diabetes confimation (75
                                    g load, fasting, 1 hour & 2 hour test)</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input formControlName="GTT3" type="checkbox" />
                                <span style="white-space: nowrap"
                                    >GTT - non-gestational diabetes</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input
                                    formControlName="hemoglobin"
                                    type="checkbox"
                                />
                                <span style="white-space: nowrap"
                                    >Hemoglobin A1c</span
                                >
                            </div>
                            <div style="display: flex; align-items: center">
                                <input formControlName="ACR" type="checkbox" />
                                <span style="white-space: nowrap"
                                    >Albumin/creatinine ratio (ACR) -
                                    Urine</span
                                >
                            </div>
                        </div>

                        <div formGroupName="LIPIDS">
                            <div style="margin-top: 4px">
                                <label style="text-decoration: underline"
                                    >LIPIDS
                                </label>
                            </div>

                            <div>
                                <label>✓ One box only.</label>
                            </div>
                            <div>
                                Note: Fasting is not required for any of the
                                panels but clinician may specifically instruct
                                patient to fast for 10 hours in select
                                circumstances [e.g. history of triglycerides>
                                4.5 mmol/L], independent of laboratory
                                requirements.
                            </div>

                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    gap: 4px;
                                    border-bottom: 1px solid #294c95;
                                "
                            >
                                <label class="shaded"
                                    >Full Lipid Profile - Total, HDL, non-HDL,
                                    LDL cholesterol, & triglycerides (Baseline
                                    or Follow-up of complex dyslipidemia)
                                    <input
                                        formControlName="fullLipidProfile"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Follow-up Lipid Profile - Total, HDL & Non
                                    HDL cholesterol only
                                    <input
                                        formControlName="followUpLipidProfile"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Apo B (not available with lipid profiles
                                    unless diagnosis of complex dyslipidemia is
                                    indicated)
                                    <input
                                        formControlName="apoB"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>

                        <div formGroupName="THYROID_FUNCTION">
                            <div style="margin-top: 4px">
                                <label style="text-decoration: underline"
                                    >THYROID FUNCTION
                                </label>
                            </div>
                            <div>
                                For other thyroid investigations, please order
                                specific test below and provide diagnosis
                            </div>

                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    gap: 4px;
                                    border-bottom: 1px solid #294c95;
                                "
                            >
                                <label class="shaded"
                                    >Monitor thyroid replacement therapy (TSH
                                    Only)
                                    <input
                                        formControlName="TSH"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Suspected Hypothyroidism (TSH first, fT4 if
                                    indicated)
                                    <input
                                        formControlName="TSH_fT4"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Suspected Hyperthyroidism(TSH first, fT4 &
                                    fT3 if indicated)
                                    <input
                                        formControlName="TSH_fT4_fT3"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                        <div formGroupName="OTHER_CHEMISTRY_TESTS">
                            <div style="margin-top: 4px">
                                <label style="text-decoration: underline"
                                    >OTHER CHEMISTRY TESTS
                                </label>
                            </div>

                            <div
                                style="
                                    display: grid;
                                    grid-template-columns: repeat(2, 1fr);
                                    grid-template-rows: repeat(9, 1fr);
                                    grid-column-gap: 0px;
                                    grid-row-gap: 0px;
                                "
                            >
                                <div style="grid-area: 1 / 1 / 2 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="sodium"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Sodium</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 1 / 2 / 2 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="eGFR"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Creatinine/eGFR</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 2 / 1 / 3 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="potassium"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Potassium</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 2 / 2 / 3 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="calcium"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Calcium</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 3 / 1 / 4 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="albumin"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Albumin</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 3 / 2 / 4 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="CK"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Creatine kinase (CK)</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 4 / 1 / 5 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="alkPhos"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Alk phos</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 4 / 2 / 5 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="PSA1"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >PSA - Known or suspected
                                            prostate</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 5 / 1 / 6 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="ALT"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >ALT</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 5 / 2 / 6 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <div style="width: 20px"></div>
                                        <span style="white-space: nowrap"
                                            >cancer (MSP billable)</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 6 / 1 / 7 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="B12"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >B12</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 6 / 2 / 7 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="PSA2"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >PSA screening (self-pay)</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 7 / 1 / 8 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="bilirubin"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Bilirubin</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 7 / 2 / 8 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="pregnancyTest"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >Pregnancy Test</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 8 / 1 / 9 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="GGT"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >GGT</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 8 / 2 / 9 / 3">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="bHCG"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >ß-HCG - quanlitaittaivtieve</span
                                        >
                                    </div>
                                </div>
                                <div style="grid-area: 9 / 1 / 10 / 2">
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <input
                                            formControlName="tProtein"
                                            type="checkbox"
                                        />
                                        <span style="white-space: nowrap"
                                            >T. Protein</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            style="
                                border-top: 1px solid #294c95;
                                margin: 4px -4px;
                            "
                        ></div>
                        <div>
                            The personal information collected on this form and
                            any medical data subsequently developed will be used
                            and disclosed only as permitted or required by the
                            Personal Information Protection Act (and related
                            acts and regulations) of British Columbia. LifeLabs
                            privacy policy is available at www.lifelabs.com. Use
                            of this form implies consent for the use of
                            de-identified patient data and specimens for quality
                            assurance purposes.
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="HEPATITIS_SEROLOGY"
                    class="HEPATITIS_SEROLOGY"
                    style="
                        border-top: 2px solid #7388b8;
                        border-left: 2px solid #7388b8;
                    "
                >
                    <div class="heading">HEPATITIS SEROLOGY</div>

                    <div style="padding: 4px">
                        <div
                            style="
                                display: flex;
                                flex-direction: column;
                                gap: 10px;
                            "
                        >
                            <div>
                                <label class="shaded"
                                    ><b
                                        >Acute viral hepatitis undefined
                                        etiology</b
                                    >
                                    <input
                                        formControlName="acuteHepatitis"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <div style="margin-left: 20px">
                                    Hepatitis A (anti-HAV lgM)
                                </div>
                                <div style="margin-left: 20px">
                                    Hepatitis B (HBsAg, anti-HBc)
                                </div>
                                <div style="margin-left: 20px">
                                    Hepatitis C (anti-HCV)
                                </div>
                            </div>
                            <div>
                                <label class="shaded"
                                    ><b
                                        >Chronic viral hepatitis undefined
                                        etiology</b
                                    >
                                    <input
                                        formControlName="chronicHepatitis"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <div style="margin-left: 20px">
                                    Hepatitis B (HBsAg, anti-HBc, anti-HBs)
                                </div>
                                <div style="margin-left: 20px">
                                    Hepatitis C (anti-HCV)
                                </div>
                            </div>
                            <div>
                                <div>
                                    <b
                                        >Investigation of hepatitis immune
                                        status</b
                                    >
                                </div>
                                <label class="shaded"
                                    >Hepatitis A (anti-HAV, total)
                                    <input
                                        formControlName="hepatitisA"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <label class="shaded"
                                    >Hepatitis B (anti-HBs)
                                    <input
                                        formControlName="hepatitisB"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div>
                                <div>
                                    <b>Hepatitis marker(s)</b>
                                </div>
                                <label class="shaded"
                                    >HBsAg
                                    <input
                                        formControlName="HBsAg"
                                        type="checkbox"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                                <div>
                                    (For other hepatitis markers, please order
                                    specific test(s) below)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="HIV_SEROLOGY"
                    class="HIV_SEROLOGY"
                    style="
                        border-top: 2px solid #7388b8;
                        border-left: 2px solid #7388b8;
                    "
                >
                    <div class="heading">HIV SEROLOGY</div>

                    <div style="padding: 4px">
                        <div style="display: flex; align-items: center">
                            <input
                                formControlName="HIV_serology"
                                type="checkbox"
                            />
                            <span style="white-space: nowrap"
                                >HIV Serology</span
                            >
                        </div>
                        <div style="margin-left: 20px">
                            (patient has the legal right to choose not to have
                            their name and address reported to public health =
                            non-nominal reporting)
                        </div>
                        <div style="margin-left: 20px">
                            <div style="display: flex; align-items: center">
                                <input
                                    formControlName="nonNominalReporting"
                                    type="checkbox"
                                />
                                <span style="white-space: nowrap"
                                    >Non-nominal reporting</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    formGroupName="OTHER_TESTS"
                    class="OTHER_TESTS"
                    style="
                        border-left: 2px solid #7388b8;
                        border-top: 2px solid #7388b8;
                    "
                >
                    <div
                        class="heading"
                        style="display: flex; gap: 4px; align-items: center"
                    >
                        OTHER TESTS
                        <div
                            style="
                                font-size: 10px;
                                line-height: 12px;
                                text-align: left;
                            "
                        >
                            Standing Orders Include expiry & frequency
                        </div>
                    </div>
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            gap: 4px;
                            margin-top: 4px;
                            padding-bottom: 8px;
                        "
                    >
                        <div style="display: flex; align-items: center">
                            <input formControlName="ECG" type="checkbox" />
                            <span style="white-space: nowrap"><b>ECG</b></span>
                        </div>
                        <div style="display: flex; align-items: center">
                            <input formControlName="FIT1" type="checkbox" />
                            <span style="white-space: nowrap"
                                >FIT (Age 50-74 asymptomatic q2y) Copy to Colon
                                Screening Program</span
                            >
                        </div>
                        <div style="display: flex; align-items: center">
                            <input formControlName="FIT2" type="checkbox" />
                            <span style="white-space: nowrap"
                                >FIT No copy to Colon Screening Program</span
                            >
                        </div>
                    </div>
                </div>
                <div
                    class="Standing_Order_requests"
                    style="
                        border-left: 2px solid #7388b8;
                        border-top: 2px solid #7388b8;
                    "
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            height: calc(100% - 5px);
                            color: red;
                            padding: 4px;
                        "
                    >
                        <textarea
                            formControlName="standingOrderRequests"
                            rows="10"
                            style="
                                white-space: pre-wrap;
                                overflow-wrap: anywhere;
                                word-break: break-word;
                            "
                        ></textarea>
                        Standing Order requests - expiry and frequency must be
                        indicated
                    </div>
                </div>
                <div
                    class="DATE"
                    style="
                        border-left: 2px solid #7388b8;
                        border-top: 2px solid #7388b8;
                    "
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            height: calc(100% - 5px);
                            padding: 4px;
                        "
                    >
                        <div>Date</div>
                        <input formControlName="date" type="text" />
                        <div>
                            Requisition is valid for one year from the date of
                            issue.
                        </div>
                    </div>
                </div>
                <div
                    class="Signature"
                    style="
                        border-left: 2px solid #7388b8;
                        border-top: 2px solid #7388b8;
                    "
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            height: calc(100% - 5px);
                            padding: 4px;
                        "
                    >
                        Practitioner Signature:
                        <img
                            *ngIf="form.value.signature as signature"
                            alt="Signature"
                            [src]="'assets/signatures/' + signature + '.png'"
                        />
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="templateVariant === 'lgv_paid'">
            <div formGroupName="LIFELABS" style="margin-top: 20px; border: 1px solid #000; font-family: Calibri, Arial, sans-serif; font-size: 13px;">

                <!-- Page 2 header -->
                <div style="background: #87CEEB; padding: 10px 14px; font-weight: bold; font-size: 17px; border-bottom: 1px solid #000; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
                    LifeLabs Requisition — Page 2 (A7339)
                </div>

                <!-- Ordering Doctor row -->
                <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
                    <div style="padding: 5px 10px; font-size: 12px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Ordering Doctor:</div>
                    <div style="padding: 5px 10px; display: flex; align-items: center; gap: 6px;">
                        <input formControlName="danTalya" type="checkbox" style="cursor: pointer;" />
                        <span>Dan Talya, NP &nbsp;&nbsp; ON4331</span>
                    </div>
                </div>

                <!-- Fasting row -->
                <div style="display: grid; grid-template-columns: 2fr 3fr; border-bottom: 1px solid #000;">
                    <div style="padding: 6px 10px; border-right: 1px solid #000; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                        <span style="font-weight: bold; font-size: 12px;">Fasting</span>
                        <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                            <input formControlName="fastingNo" type="checkbox" (change)="onLifelabsFastingNoChange($any($event.target).checked)" /> No
                        </label>
                        <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                            <input formControlName="fastingYes" type="checkbox" (change)="onLifelabsFastingYesChange($any($event.target).checked)" /> Yes —
                        </label>
                        <input formControlName="fastingHours" type="text" style="width: 36px; border: none; border-bottom: 1px solid #000; text-align: center;" /> hrs
                    </div>
                    <div style="padding: 6px 10px; font-size: 12px;">
                        <div style="font-weight: bold; margin-bottom: 4px;">Diagnosis / Comments:</div>
                        <input formControlName="diagnosisComments" type="text" maxlength="200" style="width: 100%; border: none; border-bottom: 1px solid #aaa; font-size: 12px; background: transparent;" />
                    </div>
                </div>

                <!-- PSC staff enter header -->
                <div style="padding: 6px 10px; font-weight: bold; font-size: 13px; border-bottom: 1px solid #000; background: #f5f5f5;">
                    PSC staff enter:
                </div>

                <!-- Test checkboxes -->
                <div style="padding: 10px 14px; display: flex; flex-direction: column; gap: 8px; font-size: 13px;">
                    <label *ngIf="customerGender?.toLowerCase() !== 'female' && customerGender?.toLowerCase() !== 'f'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                        <input formControlName="psaTotal" type="checkbox" />
                        PSA total
                    </label>
                    <label *ngIf="!customerGender || customerGender === 'male' || customerGender === 'm'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                        <input formControlName="shbg" type="checkbox" />
                        Sex Hormone Binding Globulin
                    </label>
                    <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                        <input formControlName="vitaminD25" type="checkbox" />
                        Vitamin D-25
                    </label>
                </div>

            </div>
        </ng-container>
    </form>
</div>